import React from 'react';

/**
 * Shared loading UI. Uses a CSS spinner (no react-loading) for consistent size and look.
 * `type` kept for API compatibility with existing call sites (ignored).
 * `color` maps to spinner accent; use #fff / #ffffff on dark backgrounds.
 */
function LoadingScreen({ type: _type, color, message = true }) {
  const c = (color || '#4f46e5').toString().toLowerCase().replace(/\s/g, '');
  const whiteSpinner = c === '#fff' || c === '#ffffff';

  const spinner = (
    <div
      className={`h-10 w-10 shrink-0 rounded-full border-2 animate-spin ${
        whiteSpinner ? 'border-white/25 border-t-white' : 'border-slate-200'
      }`}
      style={
        whiteSpinner
          ? undefined
          : {
              borderTopColor:
                color && String(color).startsWith('#') ? color : '#4f46e5',
            }
      }
      aria-hidden
    />
  );

  return (
    <div
      className="flex flex-col justify-center items-center h-full w-full my-2 min-h-[160px] px-4 py-6"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="sr-only">Loading</span>
      {spinner}
      {message && (
        <p
          className={`mt-4 text-sm font-medium text-center max-w-xs ${
            whiteSpinner ? 'text-slate-300' : 'text-slate-500'
          }`}
        >
          Loading…
        </p>
      )}
    </div>
  );
}

export default LoadingScreen;
